<template>
  <div class="category-courses-page">
    <!-- Hero Section -->
    <div class="hero-section">
      <div class="hero-content">
        <div class="hero-icon">
          <i class="fas fa-graduation-cap"></i>
        </div>
        <h1 class="hero-title">{{ $t("category_courses.page_title") }}</h1>
        <p class="hero-subtitle">{{ $t("category_courses.page_subtitle") }}</p>
      </div>
      <div class="hero-decoration">
        <div class="circle circle-1"></div>
        <div class="circle circle-2"></div>
        <div class="circle circle-3"></div>
      </div>
    </div>

    <!-- Main Content -->
    <!-- Bootstrap Modal -->
    <div
      class="modal fade"
      id="customCoursesModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="customCoursesModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="customCoursesModalLabel">
              {{ $t("category_courses.available_courses") }}
            </h5>
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <i class="fa fa-close"></i>
            </button>
          </div>
          <div
            class="modal-body custom-bundle-modal-body"
            style="min-height: 600px"
          >
            <div
              class="row custom-bundle-courses-container"
              style="height: 450px; overflow: scroll"
            >
              <!-- رسالة عدم وجود دورات -->
              <div
                v-if="customCourses.length === 0 && !isLoadingCourses"
                class="col-12"
              >
                <div
                  class="alert alert-warning text-center"
                  style="border-radius: 20px; margin: 20px"
                >
                  <b style="font-size: 23px">{{
                    $t("category_courses.no_courses")
                  }}</b
                  ><br />
                  <i style="font-size: 120px" class="fa fa-alert"></i>
                </div>
              </div>

              <!-- عرض الدورات -->
              <div
                v-for="course in customCourses"
                :key="course.id"
                class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-6"
              >
                <div class="card text-center">
                  <div class="card-body" style="padding: 5px">
                    <div class="m-1 blog__card--thumbnail">
                      <img
                        class="rounded"
                        :src="course.image"
                        @error="setDefaultImage"
                        alt="Course Thumbnail"
                      />
                    </div>
                    <h5 class="mt-3">
                      <a
                        class="text-success"
                        :href="`/course-details?id=${course.id}`"
                        style="font-size: 11px; font-weight: 800"
                      >
                        {{ course.title }}
                      </a>
                    </h5>
                    <small style="color: silver; font-weight: 700"
                      >{{ course.user.fname }} {{ course.user.lname }}</small
                    >
                    <div class="mt-2">
                      <template
                        v-if="
                          (course.price === null || course.price === 0) &&
                          (course.discount_price === null || course.discount_price === 0)
                        "
                      >
                        <h3 class="text-dark">{{ $t("course.free") }}</h3>
                      </template>
                      <template v-else-if="course.discount_price">
                        <h3 class="text-dark">
                          {{ course.discount_price }} {{ $appCurrency }}
                        </h3>
                        <h4 class="text-muted text-decoration-line-through">
                          {{ course.price }} {{ $appCurrency }}
                        </h4>
                      </template>
                      <template v-else>
                        <h3 class="text-dark">
                          {{ course.price }} {{ $appCurrency }}
                        </h3>
                      </template>

                      <button
                        v-if="!allSelectedCourses.includes(course.id)"
                        style="padding: 6px"
                        class="btn btn-sm btn-success"
                        @click="addToSelectedCourses(course.id)"
                      >
                        {{ $t("category_courses.add_to_bundle") }}
                      </button>
                      <button
                        v-else
                        style="padding: 6px"
                        class="btn btn-sm btn-secondary"
                        @click="removeFromSelectedCourses(course.id)"
                      >
                        {{ $t("category_courses.remove_from_bundle") }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <nav
                v-if="customCourseLinks && customCourseLinks.links"
                class="col-12 mt-3 d-flex justify-content-center"
              >
                <ul class="pagination">
                  <!-- Previous -->
                  <li
                    class="page-item"
                    :class="{ disabled: !customCourseLinks.links[0].url }"
                  >
                    <button
                      class="page-link"
                      style="font-weight: 700"
                      @click="
                        customCourseLinks.links[0].url &&
                          fetchCustomBundle(customCourseLinks.links[0].page)
                      "
                    >
                      &laquo; {{ $t("common.prev") }}
                    </button>
                  </li>

                  <!-- أرقام الصفحات المختصرة -->
                  <li
                    v-for="(link, index) in customCourseLinks.links.slice(
                      1,
                      customCourseLinks.links.length - 1
                    )"
                    :key="link.label"
                    v-if="
                      index < 5 || index === customCourseLinks.links.length - 2
                    "
                    class="page-item"
                    :class="{ active: link.active }"
                  >
                    <button
                      class="page-link"
                      @click="link.url && fetchCustomBundle(link.page)"
                    >
                      {{
                        index === 5 && customCourseLinks.links.length > 7
                          ? "..."
                          : link.label.replace(/&laquo;|&raquo;/g, "")
                      }}
                    </button>
                  </li>

                  <!-- Next -->
                  <li
                    class="page-item"
                    :class="{
                      disabled:
                        !customCourseLinks.links[
                          customCourseLinks.links.length - 1
                        ].url,
                    }"
                  >
                    <button
                      class="page-link text-success"
                      style="font-weight: 700"
                      @click="
                        customCourseLinks.links[
                          customCourseLinks.links.length - 1
                        ].url &&
                          fetchCustomBundle(
                            customCourseLinks.links[
                              customCourseLinks.links.length - 1
                            ].page
                          )
                      "
                    >
                      {{ $t("common.next") }} &raquo;
                    </button>
                  </li>
                </ul>
              </nav>
            </div>

            <!-- الفاتورة أسفل الصفحة -->
            <div
              v-if="customCourses.length !== 0"
              class="invoice-section sticky-invoice"
            >
              <div>
                <p>
                  {{ $t("category_courses.total_price") }}: {{ basePrice }}
                  <span class="badge badge-dark"
                    >{{ $t("category_courses.discount") }} :
                    {{ applicableDiscount }}%</span
                  >
                </p>
                <p>
                  {{ $t("category_courses.total_after_discount") }}:
                  {{ totalPrice.toFixed(2) }} {{ $appCurrency }}
                </p>
              </div>
              <div class="text-center mt-4">
                <button
                  @click="confirmEnroll"
                  class="btn btn-sm btn-primary btn-lg"
                  :disabled="isLoading"
                >
                  <span v-if="isLoading"
                    ><i class="fa fa-spinner fa-spin"></i>
                    {{ $t("common.please_wait") }}</span
                  >
                  <span v-else>
                    {{ $t("common.buy_now") }}
                    <i class="fa fa-check-circle"></i>
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Trigger Modal Button -->
    <div id="kt_app_content" class="app-content flex-column-fluid">
      <div id="kt_app_content_container" class="app-container container-fluid">
        <div class="row g-5 g-xl-10 mb-5 mb-xl-10">
          <div class="card">
            <div class="card-body">
              <ul
                class="nav nav-pills mb-3"
                style="display: flex; justify-content: center"
                id="pills-tab"
                role="tablist"
              >
                <li class="nav-item">
                  <a
                    class="nav-link"
                    id="pills-home-tab"
                    data-bs-toggle="pill"
                    href="#pills-home"
                    role="tab"
                    aria-controls="pills-home"
                    aria-selected="true"
                  >
                    {{ $t("category_courses.tab_bundles") }}
                    <i class="fas fa-book"></i
                  ></a>
                </li>
                <li class="nav-item">
                  <a
                    class="nav-link active"
                    id="pills-profile-tab"
                    data-bs-toggle="pill"
                    href="#pills-profile"
                    role="tab"
                    aria-controls="pills-profile"
                    aria-selected="false"
                  >
                    {{ $t("category_courses.tab_courses") }}
                    <i class="fas fa-book-open"></i
                  ></a>
                </li>
                <li class="nav-item">
                  <a
                    class="nav-link"
                    id="pills-instructors-tab"
                    data-bs-toggle="pill"
                    href="#pills-instructors"
                    role="tab"
                    aria-controls="pills-instructors"
                    aria-selected="true"
                  >
                    {{ $t("category_courses.tab_instructors") }}
                    <i class="fas fa-users"></i
                  ></a>
                </li>
              </ul>
            </div>
            <!-- end card body -->
          </div>

          <div class="tab-content" id="pills-tabContent">
            <!-- Courses Tab -->

            <div
              class="tab-pane fade show active"
              id="pills-profile"
              role="tabpanel"
              aria-labelledby="pills-profile-tab"
            >
              <button
                type="button"
                style="
                  margin-bottom: 30px;
                  width: 100%;
                  font-size: small;
                  font-weight: 700;
                  color: #00c630;
                  background: #0d7d3a14;
                  border: 2px solid #00c630;
                "
                class="btn btn-outline-success"
                data-bs-toggle="modal"
                data-bs-target="#customCoursesModal"
              >
                {{ $t("category_courses.make_custom_bundle") }}
                <i class="fa fa-plus"></i>
              </button>
              <div class="row g-4" id="coursesContainer">
                <!-- Loading State -->
                <div v-if="isLoadingCourses" class="col-12 py-5">
                  <div class="loading-state">
                    <div class="loading-spinner">
                      <div class="spinner-ring"></div>
                      <div class="spinner-ring"></div>
                      <div class="spinner-ring"></div>
                    </div>
                    <p class="loading-text">{{ $t("common.loading") }}</p>
                  </div>
                </div>
                <!-- Empty State - يظهر فقط بعد اكتمال التحميل الأول -->
                <div
                  v-else-if="courses.length === 0 && !isInitialCoursesFetch"
                  class="col-12"
                >
                  <div class="empty-state">
                    <div class="empty-icon">
                      <i class="fas fa-book-open"></i>
                    </div>
                    <h3>{{ $t("category_courses.no_courses") }}</h3>
                  </div>
                </div>
                <!-- Loading placeholder أثناء التحميل الأول -->
                <div
                  v-else-if="courses.length === 0 && isInitialCoursesFetch"
                  class="col-12 py-5"
                >
                  <div class="loading-state">
                    <div class="loading-spinner">
                      <div class="spinner-ring"></div>
                      <div class="spinner-ring"></div>
                      <div class="spinner-ring"></div>
                    </div>
                    <p class="loading-text">{{ $t("common.loading") }}</p>
                  </div>
                </div>
                <div
                  v-for="course in courses"
                  :key="course.id"
                  class="col-xl-3 col-lg-4 col-md-6 col-sm-6"
                >
                  <div class="course-card">
                    <div class="course-image-wrapper">
                      <img
                        :src="`${course.image}`"
                        @error="setDefaultImage"
                        alt="Course Thumbnail"
                        class="course-image"
                      />
                      <div class="course-overlay">
                        <a
                          :href="`/course-details?id=${course.id}`"
                          class="view-course-btn"
                        >
                          <i class="fas fa-play"></i>
                        </a>
                      </div>
                      <div v-if="course.discount_price" class="discount-badge">
                        {{
                          calculateDiscountPercentage(
                            course.price,
                            course.discount_price
                          )
                        }}% {{ $t("bundle.discount") }}
                      </div>
                    </div>
                    <div class="course-content">
                      <h5 class="course-title">
                        <a :href="`/course-details?id=${course.id}`">{{
                          course.title
                        }}</a>
                      </h5>
                      <div class="course-instructor">
                        <i class="fas fa-user-tie"></i>
                        <span
                          >{{ course.user.fname }} {{ course.user.lname }}</span
                        >
                      </div>
                      <div class="course-price-section">
                        <template
                          v-if="
                            (course.price === null || course.price === 0) &&
                            (course.discount_price === null || course.discount_price === 0)
                          "
                        >
                          <span class="price-free">{{
                            $t("course.free")
                          }}</span>
                        </template>
                        <template v-else-if="course.discount_price">
                          <span class="price-current"
                            >{{ course.discount_price }}
                            {{ $appCurrency }}</span
                          >
                          <span class="price-old"
                            >{{ course.price }} {{ $appCurrency }}</span
                          >
                        </template>
                        <template v-else>
                          <span class="price-current"
                            >{{ course.price }} {{ $appCurrency }}</span
                          >
                        </template>
                      </div>
                      <button
                        v-if="
                          course.price != null || course.discount_price != null
                        "
                        class="add-to-cart-btn"
                        @click="addToCart(course.id, $event, 'course')"
                      >
                        <i class="fas fa-cart-plus"></i>
                        <span>{{ $t("bundle.add_to_cart") }}</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div id="pagination"></div>
            </div>
            <!-- Bundles Tab -->
            <div
              class="tab-pane fade"
              id="pills-home"
              role="tabpanel"
              aria-labelledby="pills-home-tab"
            >
              <button
                type="button"
                class="custom-bundle-btn"
                data-bs-toggle="modal"
                data-bs-target="#customCoursesModal"
              >
                <i class="fa fa-plus-circle"></i>
                <span>{{ $t("category_courses.make_custom_bundle") }}</span>
              </button>
              <div class="row g-4" id="bundleContainer">
                <div
                  v-if="isLoadingBundles"
                  class="col-12 d-flex justify-content-center align-items-center py-5"
                >
                  <div class="loading-spinner">
                    <div class="spinner-ring"></div>
                    <div class="spinner-ring"></div>
                    <div class="spinner-ring"></div>
                  </div>
                </div>
                <div
                  v-else-if="bundles.length === 0 && !isInitialBundlesFetch"
                  class="col-12"
                >
                  <div class="empty-state">
                    <div class="empty-icon">
                      <i class="fas fa-box-open"></i>
                    </div>
                    <h3>{{ $t("category_courses.no_bundles") }}</h3>
                  </div>
                </div>
                <div
                  v-else-if="bundles.length === 0 && isInitialBundlesFetch"
                  class="col-12 py-5"
                >
                  <div class="loading-state">
                    <div class="loading-spinner">
                      <div class="spinner-ring"></div>
                      <div class="spinner-ring"></div>
                      <div class="spinner-ring"></div>
                    </div>
                    <p class="loading-text">{{ $t("common.loading") }}</p>
                  </div>
                </div>
                <div
                  v-for="bundle in bundles"
                  :key="bundle.id"
                  class="col-xl-3 col-lg-4 col-md-6 col-sm-6"
                >
                  <div class="course-card bundle-card">
                    <div class="course-image-wrapper">
                      <img
                        :src="`${bundle.preview_image}`"
                        @error="setDefaultImage"
                        alt="Bundle Thumbnail"
                        class="course-image"
                      />
                      <div class="course-overlay">
                        <a
                          :href="`/bundle-details?id=${bundle.id}`"
                          class="view-course-btn"
                        >
                          <i class="fas fa-layer-group"></i>
                        </a>
                      </div>
                      <div v-if="bundle.discount_price" class="discount-badge">
                        {{
                          calculateDiscountPercentage(
                            bundle.price,
                            bundle.discount_price
                          )
                        }}% {{ $t("bundle.discount") }}
                      </div>
                    </div>
                    <div class="course-content">
                      <h5 class="course-title">
                        <a :href="`/bundle-details?id=${bundle.id}`">{{
                          bundle.title
                        }}</a>
                      </h5>
                      <div class="course-instructor">
                        <i class="fas fa-user-tie"></i>
                        <span>{{ bundle.user }}</span>
                      </div>
                      <div class="course-price-section">
                        <template
                          v-if="
                            (bundle.price === null || bundle.price === 0) &&
                            (bundle.discount_price === null || bundle.discount_price === 0)
                          "
                        >
                          <span class="price-free">{{
                            $t("course.free")
                          }}</span>
                        </template>
                        <template v-else-if="bundle.discount_price">
                          <span class="price-current"
                            >{{ bundle.discount_price }}
                            {{ $appCurrency }}</span
                          >
                          <span class="price-old"
                            >{{ bundle.price }} {{ $appCurrency }}</span
                          >
                        </template>
                        <template v-else>
                          <span class="price-current"
                            >{{ bundle.price }} {{ $appCurrency }}</span
                          >
                        </template>
                      </div>
                      <button
                        v-if="
                          bundle.price != null || bundle.discount_price != null
                        "
                        class="add-to-cart-btn"
                        :class="{ 'in-cart': cartBundles.includes(bundle.id) }"
                        @click="toggleBundleCart(bundle.id, $event)"
                      >
                        <i
                          :class="
                            cartBundles.includes(bundle.id)
                              ? 'fas fa-check-circle'
                              : 'fas fa-cart-plus'
                          "
                        ></i>
                        <span>{{
                          cartBundles.includes(bundle.id)
                            ? "تم الإضافة"
                            : $t("bundle.add_to_cart")
                        }}</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div id="paginationBundle"></div>
            </div>
            <div
              class="tab-pane fade"
              id="pills-instructors"
              role="tabpanel"
              aria-labelledby="pills-instructors-tab"
            >
              <InstructorsList />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import "twbs-pagination";
import Swal from "sweetalert2";
import InstructorsList from "./InstructorsList.vue";
import { baseUrl, apiUrl } from "@/utils/api"; // Adjust the import path according to your project structure
import {
  showCart,
  addToCart,
  confirmPurchase,
  applyCoupon,
  removeCartItem,
  removeCoupon,
  generateCartInvoice,
} from "@/utils/cart";

export default {
  name: "CategoryCourses",
  components: {
    InstructorsList,
  },
  data() {
    return {
      customCourses: [], // قائمة الدورات
      token: localStorage.getItem("access_token"),
      respo: localStorage.getItem("respo"),
      courses: [],
      bundles: [],
      allCoursesCache: [], // لتخزين كل الكورسات التي تم تحميلها من كل الصفحات

      selectedCourseIds: [], // الدورات المختارة
      discounts: [], // خصومات
      minCourses: 0,
      maxCourses: 0,
      isLoadingCourses: true,
      isLoadingBundles: true,
      isLoading: false,
      defaultImage: "/assets/img/acad-icon.png",

      // Paginator جديد للدورات
      customCoursePagination: {},
      customCourseLinks: [],
      currentCustomCoursePage: 1,

      totalCoursesPages: 0,
      totalBundlesPages: 0,
      currentPage: 1,
      coursesPerPage: 20,
      bundlesPerPage: 20,
      baseUrl: baseUrl,
      allSelectedCourses: [], // لتخزين كل الدورات المختارة عبر الصفحات

      isInitialCoursesFetch: true, // Flag to check initial fetch
      isInitialBundlesFetch: true, // Flag to check initial fetch
      cartBundles: [], // Track bundles in cart
    };
  },

  mounted() {
    this.fetchCourses(this.currentPage);
    this.fetchBundles(this.currentPage);
    this.fetchCustomBundle();
    this.loadCartBundles();
  },
  methods: {
    async confirmEnroll() {
      // Check if selected courses are less than minimum required
      if (this.allSelectedCourses.length < this.minCourses) {
        Swal.fire({
          icon: "warning",
          title:
            this.$t("category_courses.min_courses_alert", {
              min: this.minCourses,
            }) ||
            `هذه الباقة يجب أن تحتوي على ${this.minCourses} دورات على الأقل`,
          text: "",
          confirmButtonText: this.$t("common.ok") || "موافق",
        });
        return;
      }

      // عرض رسالة تأكيد قبل بدء عملية الاشتراك
      const result = await Swal.fire({
        title: "هل أنت متأكد أنك تريد الاشتراك في هذه الدورات؟",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "نعم، اشتراك",
        cancelButtonText: "إلغاء",
      });

      // إذا ضغط المستخدم على "نعم"
      if (result.isConfirmed) {
        this.enrollInCourses(); // استدعاء دالة الاشتراك
      }
    },

    async enrollInCourses() {
      this.isLoading = true; // تشغيل اللودر عند بدء الاشتراك
      try {
        // تحقق من أن هناك دورات محددة للتسجيل فيها
        if (this.allSelectedCourses.length === 0) {
          Swal.fire({
            icon: "warning",
            title: "يرجى إختيار دورات للإشتراك أولاً",
            text: "",
            confirmButtonText: "موافق",
          });
          this.isLoading = false; // إيقاف اللودر إذا لم يتم تحديد دورات
          return;
        }

        const urlParams = new URLSearchParams(window.location.search);
        const value_id = urlParams.get("value_id");
        const value = urlParams.get("value");

        // بيانات الطلب
        const enrollmentData = {
          courses_ids: this.allSelectedCourses, // استخدام allSelectedCourses الآن
        };

        if (value_id === "subcategory_id") {
          enrollmentData.subcategory_id = value;
        } else if (value_id === "childcategory_id") {
          enrollmentData.childcategory_id = value;
          const sub = urlParams.get("sub");
          if (sub) enrollmentData.subcategory_id = sub; // إضافة sub_category إذا موجود
        }

        // إرسال الطلب
        const response = await fetch(`${apiUrl}/custom-bundles/enroll`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "x-country-code": window.appRegion.phone_code,
            Authorization: `Bearer ${this.token}`,
          },
          body: JSON.stringify(enrollmentData),
        });

        // التحقق من استجابة الطلب
        const result = await response.json(); // الحصول على محتوى الاستجابة

        if (!response.ok) {
          let errorMessage =
            "فشل عملية الإشتراك ، الرجاء التأكد وإعادة المحاولة";
          if (result.message) {
            errorMessage = result.message;
          }
          Swal.fire({
            icon: "error",
            title: errorMessage,
            text: "",
            confirmButtonText: "موافق",
          });
        } else {
          Swal.fire({
            icon: "success",
            title: "تم الشراء بنجاح",
            text: "نتمنى لك التوفيق",
          }).then((result) => {
            if (result.isConfirmed) {
              location.reload();
            }
          });
        }
      } catch (error) {
        console.error("Error enrolling in courses:", error);
        Swal.fire({
          icon: "error",
          title: "فشل عملية الإشتراك ، الرجاء التأكد وإعادة المحاولة",
          text: "",
          confirmButtonText: "موافق",
        });
      } finally {
        this.isLoading = false; // إيقاف اللودر بعد انتهاء العملية
      }
    },

    calculateDiscountPercentage(price, discountPrice) {
      if (price > 0) {
        return Math.round(((price - discountPrice) / price) * 100);
      }
      return 0;
    },
    async fetchCourses(page) {
      this.isLoadingCourses = true;
      const urlParams = new URLSearchParams(window.location.search);
      const value_id = urlParams.get("value_id");
      const value = urlParams.get("value");
      const data = {
        page: page,
        limit: this.coursesPerPage,
      };

      if (value_id === "category_id") {
        data.category_id = value;
      } else if (value_id === "subcategory_id") {
        data.subcategory_id = value;
      } else if (value_id === "childcategory_id") {
        data.childcategory_id = value;
      }

      try {
        const response = await fetch(`${apiUrl}/web/get-courses`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "x-country-code": window.appRegion.phone_code,
            Authorization: `Bearer ${this.token}`,
          },
          body: JSON.stringify(data),
        });

        const result = await response.json();
        const resData = result.courses;

        // Handle case when no courses are returned
        if (resData && resData.data) {
          this.courses = resData.data;
          if (resData.meta) {
            this.totalCoursesPages = Math.ceil(
              resData.meta.total / resData.meta.per_page
            );
            this.initializeCoursesPagination(this.totalCoursesPages);
          }
        } else {
          this.courses = [];
        }
      } catch (error) {
        console.log("Error:", error);
        this.courses = [];
      } finally {
        this.isLoadingCourses = false;
        this.isInitialCoursesFetch = false;
      }
    },
    async fetchBundles(page) {
      this.isLoadingBundles = true;
      const urlParams = new URLSearchParams(window.location.search);
      const value_id = urlParams.get("value_id");
      const value = urlParams.get("value");
      const data = {
        page: page,
        limit: this.bundlesPerPage,
      };

      if (value_id === "category_id") {
        data.category_id = value;
      } else if (value_id === "subcategory_id") {
        data.subcategory_id = value;
      } else if (value_id === "childcategory_id") {
        data.childcategory_id = value;
      }

      try {
        const response = await fetch(`${apiUrl}/web/get-bundles`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "x-country-code": window.appRegion.phone_code,
            Authorization: `Bearer ${this.token}`,
          },
          body: JSON.stringify(data),
        });

        const result = await response.json();
        const resData = result.bundle;

        // Handle case when no bundles are returned
        if (resData && resData.data) {
          this.bundles = resData.data;
          if (resData.meta) {
            this.totalBundlesPages = Math.ceil(
              resData.meta.total / resData.meta.per_page
            );
            this.initializeBundlesPagination(this.totalBundlesPages);
          }
        } else if (Array.isArray(resData)) {
          this.bundles = resData;
          if (resData.length > 0 && resData.meta) {
            this.totalBundlesPages = Math.ceil(
              resData.meta.total / resData.meta.per_page
            );
            this.initializeBundlesPagination(this.totalBundlesPages);
          }
        } else {
          this.bundles = [];
        }
      } catch (error) {
        console.log("Error:", error);
        this.bundles = [];
      } finally {
        this.isLoadingBundles = false;
        this.isInitialBundlesFetch = false;
      }
    },
    async fetchCustomBundle(page = 1) {
      try {
        const urlParams = new URLSearchParams(window.location.search);
        const value_id = urlParams.get("value_id");
        const value = urlParams.get("value");
        const data = { page }; // أضف page للـ paginate

        if (value_id === "subcategory_id") {
          data.sub_category_id = value;
        } else if (value_id === "childcategory_id") {
          data.child_category_id = value;
          const sub = urlParams.get("sub");
          data.sub_category_id = sub;
        }

        const response = await fetch(`${apiUrl}/web/get-customizable-courses`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.token}`,
            "x-country-code": window.appRegion.phone_code,
          },
          body: JSON.stringify(data),
        });

        if (!response.ok) {
          throw new Error("Failed to fetch course details");
        }

        const result = await response.json();
        result.courses.data.forEach((course) => {
          if (!this.allCoursesCache.some((c) => c.id === course.id)) {
            this.allCoursesCache.push(course);
          }
        });
        // تحديث customCourses بالـ data
        this.customCourses = result.courses.data;
        this.discounts = result.discounts;

        // تحديث min/max courses
        this.minCourses = result.sub_category.min_courses;
        this.maxCourses = result.sub_category.max_courses;

        // تحديث بيانات الـ paginate الخاصة بالدورات
        this.customCoursePagination = result.courses.meta;
        this.customCourseLinks = result.courses.meta;
        this.currentCustomCoursePage = result.courses.meta.current_page;

        console.log("Courses:", this.customCourses);
        console.log("Pagination Links:", this.customCourseLinks);
      } catch (error) {
        console.error("Error fetching course details:", error);
      } finally {
        this.isLoadingCourses = false;
      }
    },

    addToSelectedCourses(courseId) {
      if (this.allSelectedCourses.includes(courseId)) return;
      if (this.allSelectedCourses.length >= this.maxCourses) {
        Swal.fire({
          icon: "warning",
          title: `لقد وصلت إلى الحد الأقصى (${this.maxCourses}) من الدورات. الرجاء إزالة دورة لإضافة أخرى.`,
          text: "",
          confirmButtonText: "موافق",
        });
      } else {
        this.allSelectedCourses.push(courseId);
      }
    },

    removeFromSelectedCourses(courseId) {
      this.allSelectedCourses = this.allSelectedCourses.filter(
        (id) => id !== courseId
      );
    },

    initializeCoursesPagination(totalPages) {
      if (this.$coursesPagination) {
        this.$coursesPagination.destroy();
      }

      this.$nextTick(() => {
        $("#pagination").twbsPagination({
          totalPages: totalPages,
          visiblePages: 5,
          first: "الأول",
          prev: "السابق",
          next: "التالي",
          last: "الأخير",
          onPageClick: (event, page) => {
            // Only fetch courses if this is not the initial fetch
            if (!this.isInitialCoursesFetch) {
              this.fetchCourses(page);
            }
            this.isInitialCoursesFetch = false;
          },
        });
      });
    },
    initializeBundlesPagination(totalPages) {
      if (this.$bundlesPagination) {
        this.$bundlesPagination.destroy();
      }

      this.$nextTick(() => {
        $("#paginationBundle").twbsPagination({
          totalPages: totalPages,
          visiblePages: 5,
          first: "الأول",
          prev: "السابق",
          next: "التالي",
          last: "الأخير",
          onPageClick: (event, page) => {
            // Only fetch bundles if this is not the initial fetch
            if (!this.isInitialBundlesFetch) {
              this.fetchBundles(page);
            }
            this.isInitialBundlesFetch = false;
          },
        });
      });
    },
    showCart,
    addToCart,
    removeCartItem,
    setDefaultImage(event) {
      event.target.src = this.defaultImage;
    },
    loadCartBundles() {
      // Load cart bundles from API
      const token = localStorage.getItem("access_token");
      fetch(`${apiUrl}/show/cart?secret=a463c0cd-78ed-4bda-a5f6-f70c3e597dfb`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.cart && Array.isArray(data.cart)) {
            this.cartBundles = data.cart
              .filter((item) => item.bundle_id !== null)
              .map((item) => item.bundle_id);
          }
        })
        .catch((err) => console.error("Error loading cart:", err));
    },
    isBundleInCart(bundleId) {
      return this.cartBundles.includes(bundleId);
    },
    toggleBundleCart(bundleId, event) {
      const index = this.cartBundles.indexOf(bundleId);
      if (index > -1) {
        // Remove - already in cart
        this.cartBundles.splice(index, 1);
        removeCartItem(bundleId, null);
      } else {
        // Add to cart
        this.cartBundles.push(bundleId);
        addToCart(bundleId, event, "bundle");
      }
    },
  },
  computed: {
    totalCourses() {
      return this.allSelectedCourses.length;
    },
    applicableDiscount() {
      const discountObj = this.discounts.find(
        (discount) => discount.number_of_courses == this.totalCourses
      );
      return discountObj ? parseFloat(discountObj.discount) : 0;
    },
    basePrice() {
      const basePrice = this.allSelectedCourses.reduce((total, courseId) => {
        // ابحث في جميع الصفحات المختارة
        let course = this.customCourses.find((c) => c.id === courseId);
        if (!course) {
          // إذا الدورة ليست في الصفحة الحالية، ابحث عنها في allCoursesCache
          course = this.allCoursesCache.find((c) => c.id === courseId);
        }
        if (!course) return total;
        const coursePrice = course.discount_price
          ? parseFloat(course.discount_price)
          : parseFloat(course.price);
        return total + coursePrice;
      }, 0);
      return basePrice;
    },
    totalPrice() {
      const basePrice = this.basePrice;
      const discountAmount = (basePrice * this.applicableDiscount) / 100;
      return basePrice - discountAmount;
    },
  },
};
</script>

<style scoped>
/* ===== Main Page Styles ===== */
.category-courses-page {
  min-height: 100vh;
  background: linear-gradient(135deg, #f8fffe 0%, #e8fff1 100%);
  direction: rtl;
}

/* ===== Hero Section ===== */
.hero-section {
  background: linear-gradient(135deg, #00c744 0%, #00a83b 50%, #008f32 100%);
  padding: 60px 20px;
  position: relative;
  overflow: hidden;
  border-radius: 0 0 50px 50px;
  margin-bottom: 40px;
  box-shadow: 0 10px 40px rgba(0, 199, 68, 0.3);
}

.hero-content {
  text-align: center;
  position: relative;
  z-index: 2;
}

.hero-icon {
  width: 100px;
  height: 100px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px;
  backdrop-filter: blur(10px);
  animation: float 3s ease-in-out infinite;
}

.hero-icon i {
  font-size: 45px;
  color: white;
}

.hero-title {
  color: white;
  font-size: 2.5rem;
  font-weight: 800;
  margin-bottom: 10px;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.hero-subtitle {
  color: rgba(255, 255, 255, 0.9);
  font-size: 1.1rem;
  font-weight: 400;
}

.hero-decoration {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
}

.circle {
  position: absolute;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
}

.circle-1 {
  width: 200px;
  height: 200px;
  top: -50px;
  right: -50px;
  animation: pulse 4s ease-in-out infinite;
}

.circle-2 {
  width: 150px;
  height: 150px;
  bottom: -30px;
  left: 10%;
  animation: pulse 5s ease-in-out infinite 1s;
}

.circle-3 {
  width: 100px;
  height: 100px;
  top: 30%;
  left: 5%;
  animation: pulse 6s ease-in-out infinite 2s;
}

/* ===== Tabs Styling ===== */
.nav-pills {
  background: white;
  border-radius: 50px;
  padding: 8px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.05);
  display: inline-flex !important;
  gap: 8px;
}

.nav-pills .nav-link {
  border-radius: 50px;
  padding: 12px 25px;
  font-weight: 600;
  color: #718096;
  transition: all 0.3s ease;
  border: none;
}

.nav-pills .nav-link:hover {
  background: #e8fff1;
  color: #00c744;
}

.nav-pills .nav-link.active {
  background: linear-gradient(135deg, #00c744 0%, #00a83b 100%);
  color: white;
  box-shadow: 0 5px 20px rgba(0, 199, 68, 0.3);
}

.nav-pills .nav-link i {
  margin-right: 8px;
}

/* ===== Custom Bundle Button ===== */
.custom-bundle-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  width: 100%;
  padding: 18px 30px;
  margin-bottom: 30px;
  background: linear-gradient(135deg, #e8fff1 0%, #d4f7e4 100%);
  border: 2px dashed #00c744;
  border-radius: 20px;
  color: #00c744;
  font-size: 1rem;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
}

.custom-bundle-btn:hover {
  background: linear-gradient(135deg, #00c744 0%, #00a83b 100%);
  color: white;
  border-style: solid;
  transform: translateY(-3px);
  box-shadow: 0 10px 30px rgba(0, 199, 68, 0.3);
}

.custom-bundle-btn:hover i {
  color: white;
}

/* ===== Course Cards ===== */
.card {
  border: none;
  border-radius: 24px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.06);
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  overflow: hidden;
}

.card:hover {
  transform: translateY(-8px);
  box-shadow: 0 20px 50px rgba(0, 199, 68, 0.15);
}

.card .card-body {
  padding: 20px;
}

.blog__card--thumbnail img {
  width: 100%;
  height: 160px;
  object-fit: cover;
  border-radius: 16px;
}

.card h5 a {
  color: #2d3748;
  font-weight: 700;
  text-decoration: none;
  transition: color 0.3s ease;
}

.card h5 a:hover {
  color: #00c744;
}

/* ===== Course Cards New Design ===== */
.course-card {
  background: white;
  border-radius: 24px;
  overflow: hidden;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.06);
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  height: 100%;
  display: flex;
  flex-direction: column;
}

.course-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 25px 60px rgba(0, 199, 68, 0.15);
}

.course-image-wrapper {
  position: relative;
  overflow: hidden;
}

.course-image {
  width: 100%;
  height: 180px;
  object-fit: cover;
  transition: transform 0.5s ease;
}

.course-card:hover .course-image {
  transform: scale(1.1);
}

.course-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 199, 68, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.course-card:hover .course-overlay {
  opacity: 1;
}

.view-course-btn {
  width: 60px;
  height: 60px;
  background: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #00c744;
  font-size: 24px;
  text-decoration: none;
  transform: scale(0);
  transition: transform 0.3s ease 0.1s;
}

.course-card:hover .view-course-btn {
  transform: scale(1);
}

.view-course-btn:hover {
  background: #00c744;
  color: white;
}

.discount-badge {
  position: absolute;
  top: 15px;
  right: 15px;
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
  color: white;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: 700;
  box-shadow: 0 5px 15px rgba(239, 68, 68, 0.3);
}

.bundle-badge {
  position: absolute;
  top: 15px;
  left: 15px;
  background: linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%);
  color: white;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 5px;
}

.course-content {
  padding: 20px;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
}

.course-title {
  margin: 0 0 12px 0;
}

.course-title a {
  color: #2d3748;
  font-size: 1rem;
  font-weight: 700;
  text-decoration: none;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  transition: color 0.3s ease;
}

.course-title a:hover {
  color: #00c744;
}

.course-instructor {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 15px;
  color: #718096;
  font-size: 0.9rem;
}

.course-instructor i {
  color: #00c744;
}

.course-price-section {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 15px;
  flex-wrap: wrap;
  margin-top: auto;
}

.price-current {
  font-size: 1.3rem;
  font-weight: 800;
  color: #00c744;
}

.price-old {
  font-size: 0.95rem;
  color: #a0aec0;
  text-decoration: line-through;
}

.price-free {
  font-size: 1.3rem;
  font-weight: 800;
  color: #00c744;
  background: linear-gradient(135deg, #e8fff1 0%, #d4f7e4 100%);
  padding: 5px 15px;
  border-radius: 20px;
}

.add-to-cart-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  padding: 14px 20px;
  background: linear-gradient(135deg, #00c744 0%, #00a83b 100%);
  color: white;
  border: none;
  border-radius: 50px;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 8px 25px rgba(0, 199, 68, 0.25);
}

.add-to-cart-btn:hover {
  transform: translateY(-3px);
  box-shadow: 0 12px 30px rgba(0, 199, 68, 0.35);
}

.add-to-cart-btn i {
  font-size: 1.1rem;
  color: white;
}

.add-to-cart-btn span {
  color: white;
}

.add-to-cart-btn.in-cart {
  background: linear-gradient(135deg, #6c757d 0%, #5a6268 100%);
  border: 2px solid #6c757d;
  box-shadow: 0 8px 25px rgba(108, 117, 125, 0.25);
}

.add-to-cart-btn.in-cart i::before {
  content: "\f058";
}

.add-to-cart-btn.in-cart span {
  font-size: 0;
}

.add-to-cart-btn.in-cart span::after {
  content: "تم الإضافة";
  font-size: 0.95rem;
}

.add-to-cart-btn.in-cart:hover {
  background: linear-gradient(135deg, #dc3545 0%, #c82333 100%);
  border-color: #dc3545;
  box-shadow: 0 8px 25px rgba(220, 53, 69, 0.25);
}

/* ===== Empty State ===== */
.empty-state {
  text-align: center;
  padding: 60px 20px;
  background: white;
  border-radius: 24px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.05);
}

.empty-icon {
  width: 100px;
  height: 100px;
  background: linear-gradient(135deg, #e8fff1 0%, #d4f7e4 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px;
}

.empty-icon i {
  font-size: 40px;
  color: #00c744;
}

.empty-state h3 {
  color: #2d3748;
  font-size: 1.2rem;
  font-weight: 600;
  margin: 0;
}

/* ===== Loading State ===== */
.loading-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
}

.loading-text {
  margin-top: 20px;
  color: #00c744;
  font-size: 1rem;
  font-weight: 600;
}

/* ===== Loading Spinner ===== */
.loading-spinner {
  position: relative;
  width: 70px;
  height: 70px;
  margin: 0 auto;
}

.spinner-ring {
  position: absolute;
  width: 100%;
  height: 100%;
  border: 4px solid transparent;
  border-top-color: #00c744;
  border-radius: 50%;
  animation: spin 1.2s linear infinite;
}

.spinner-ring:nth-child(2) {
  width: 70%;
  height: 70%;
  top: 15%;
  left: 15%;
  border-top-color: #00a83b;
  animation-duration: 1s;
}

.spinner-ring:nth-child(3) {
  width: 40%;
  height: 40%;
  top: 30%;
  left: 30%;
  border-top-color: #008f32;
  animation-duration: 0.8s;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* ===== Buttons ===== */
.btn-success {
  background: linear-gradient(135deg, #00c744 0%, #00a83b 100%);
  border: none;
  border-radius: 50px;
  padding: 10px 20px;
  font-weight: 600;
  box-shadow: 0 5px 20px rgba(0, 199, 68, 0.25);
  transition: all 0.3s ease;
}

.btn-success:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 199, 68, 0.35);
}

.btn-success i {
  color: white !important;
}

.addtocart {
  width: 100%;
  margin-top: 10px;
}

/* ===== Loading State ===== */
.spinner-border {
  width: 50px;
  height: 50px;
}

/* ===== Empty State ===== */
.alert-warning {
  background: linear-gradient(135deg, #fff8e8 0%, #ffefcc 100%);
  border: none;
  border-radius: 20px;
  padding: 40px;
}

/* ===== Modal Styling ===== */
.modal-content {
  border: none;
  border-radius: 30px;
  overflow: hidden;
}

.modal-header {
  background: linear-gradient(135deg, #00c744 0%, #00a83b 100%);
  border: none;
  padding: 20px 30px;
}

.modal-title {
  color: white;
  font-weight: 700;
}

.modal-header .btn-secondary {
  background: rgba(255, 255, 255, 0.2);
  border: none;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
}

.modal-body {
  padding: 30px;
}

/* ===== Custom Bundle Modal Scrollbar - Always Visible ===== */
.custom-bundle-courses-container {
  overflow-y: scroll !important;
  scrollbar-width: thin;
  scrollbar-color: #00c744 #e8fff1;
}

.custom-bundle-courses-container::-webkit-scrollbar {
  width: 10px;
}

.custom-bundle-courses-container::-webkit-scrollbar-track {
  background: #e8fff1;
  border-radius: 10px;
}

.custom-bundle-courses-container::-webkit-scrollbar-thumb {
  background: linear-gradient(180deg, #00c744, #00a83b);
  border-radius: 10px;
  border: 2px solid #e8fff1;
}

.custom-bundle-courses-container::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(180deg, #00a83b, #008f32);
}

/* ===== Invoice Section ===== */
.invoice-section {
  background: linear-gradient(135deg, #f8fffe 0%, #e8fff1 100%);
  border-radius: 20px;
  padding: 25px;
  margin-top: 20px;
  border: 2px solid #00c744;
}

.invoice-section p {
  margin: 8px 0;
  font-weight: 600;
  color: #2d3748;
}

.invoice-section .badge {
  background: #00c744;
  padding: 5px 12px;
  border-radius: 20px;
  font-size: 0.85rem;
}

/* ===== Pagination ===== */
.pagination {
  gap: 8px;
}

.page-link {
  border: none;
  border-radius: 12px;
  padding: 10px 18px;
  font-weight: 600;
  color: #718096;
  background: white;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
}

.page-link:hover {
  background: #e8fff1;
  color: #00c744;
}

.page-item.active .page-link {
  background: linear-gradient(135deg, #00c744 0%, #00a83b 100%);
  color: white;
  box-shadow: 0 5px 15px rgba(0, 199, 68, 0.3);
}

/* ===== Animations ===== */
@keyframes float {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}

@keyframes pulse {
  0%,
  100% {
    transform: scale(1);
    opacity: 0.1;
  }
  50% {
    transform: scale(1.1);
    opacity: 0.2;
  }
}

/* ===== Dark Mode Support ===== */
[data-bs-theme="dark"] .category-courses-page,
[data-theme="dark"] .category-courses-page,
.dark .category-courses-page {
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
}

[data-bs-theme="dark"] .card,
[data-theme="dark"] .card,
.dark .card {
  background: #1e293b;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
}

[data-bs-theme="dark"] .card h5 a,
[data-theme="dark"] .card h5 a,
.dark .card h5 a {
  color: #f1f5f9;
}

[data-bs-theme="dark"] .nav-pills,
[data-theme="dark"] .nav-pills,
.dark .nav-pills {
  background: #1e293b;
}

[data-bs-theme="dark"] .nav-pills .nav-link,
[data-theme="dark"] .nav-pills .nav-link,
.dark .nav-pills .nav-link {
  color: #94a3b8;
}

[data-bs-theme="dark"] .nav-pills .nav-link:hover,
[data-theme="dark"] .nav-pills .nav-link:hover,
.dark .nav-pills .nav-link:hover {
  background: #0f172a;
  color: #4ade80;
}

[data-bs-theme="dark"] .custom-bundle-btn,
[data-theme="dark"] .custom-bundle-btn,
.dark .custom-bundle-btn {
  background: linear-gradient(135deg, #0f3d1c 0%, #1a5c2e 100%);
  border-color: #4ade80;
  color: #4ade80;
}

[data-bs-theme="dark"] .invoice-section,
[data-theme="dark"] .invoice-section,
.dark .invoice-section {
  background: #0f172a;
  border-color: #4ade80;
}

[data-bs-theme="dark"] .invoice-section p,
[data-theme="dark"] .invoice-section p,
.dark .invoice-section p {
  color: #f1f5f9;
}

[data-bs-theme="dark"] .modal-content,
[data-theme="dark"] .modal-content,
.dark .modal-content {
  background: #1e293b;
}

[data-bs-theme="dark"] .modal-body,
[data-theme="dark"] .modal-body,
.dark .modal-body {
  background: #1e293b;
}

[data-bs-theme="dark"] .page-link,
[data-theme="dark"] .page-link,
.dark .page-link {
  background: #1e293b;
  color: #94a3b8;
}

[data-bs-theme="dark"] .page-link:hover,
[data-theme="dark"] .page-link:hover,
.dark .page-link:hover {
  background: #0f172a;
  color: #4ade80;
}

[data-bs-theme="dark"] .alert-warning,
[data-theme="dark"] .alert-warning,
.dark .alert-warning {
  background: linear-gradient(135deg, #3d2c1c 0%, #5c3e2e 100%);
  color: #fbbf24;
}

/* Dark Mode for Course Cards */
[data-bs-theme="dark"] .course-card,
[data-theme="dark"] .course-card,
.dark .course-card {
  background: #1e293b;
}

[data-bs-theme="dark"] .course-title a,
[data-theme="dark"] .course-title a,
.dark .course-title a {
  color: #f1f5f9;
}

[data-bs-theme="dark"] .course-instructor,
[data-theme="dark"] .course-instructor,
.dark .course-instructor {
  color: #94a3b8;
}

[data-bs-theme="dark"] .price-free,
[data-theme="dark"] .price-free,
.dark .price-free {
  background: linear-gradient(135deg, #0f3d1c 0%, #1a5c2e 100%);
  color: #4ade80;
}

[data-bs-theme="dark"] .empty-state,
[data-theme="dark"] .empty-state,
.dark .empty-state {
  background: #1e293b;
}

[data-bs-theme="dark"] .empty-state h3,
[data-theme="dark"] .empty-state h3,
.dark .empty-state h3 {
  color: #f1f5f9;
}

[data-bs-theme="dark"] .empty-icon,
[data-theme="dark"] .empty-icon,
.dark .empty-icon {
  background: linear-gradient(135deg, #0f3d1c 0%, #1a5c2e 100%);
}

/* ===== Responsive ===== */
@media (max-width: 768px) {
  .hero-section {
    padding: 40px 20px;
    border-radius: 0 0 30px 30px;
  }

  .hero-title {
    font-size: 1.8rem;
  }

  .hero-icon {
    width: 80px;
    height: 80px;
  }

  .hero-icon i {
    font-size: 35px;
  }

  .nav-pills {
    flex-wrap: wrap;
    justify-content: center;
  }

  .nav-pills .nav-link {
    padding: 10px 18px;
    font-size: 0.9rem;
  }
}
</style>
